<template>
  <div>
    <alert
      :visible="!!alert_message"
      dark
      :type="type_alert"
      :message="alert_message"
      :clickClose="() => (alert_message = '')"
    />
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="promotions"
      :search="search"
      sort-by="end_date"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>OPORTUNIDADE DE COMPRA FORNECEDOR</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-checkbox
            class="mt-6"
            v-model="past_promotions"
            :disabled="loading"
            label="Mostrar Oportunidades Passadas"
          ></v-checkbox>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busca"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            dark
            to="/pedidos/configuracao/promocoes/novo"
          >
            <v-icon>mdi-plus</v-icon>
            Novo
          </v-btn>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-toolbar color="red lighten-1" dark class="text-h5"
                >Atenção</v-toolbar
              >
              <v-card-title class="text-h6">
                Tem certeza que deseja Deletar?
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete()"
                  >Fechar</v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteItemConfirm()">
                  <v-icon dark>mdi-delete</v-icon>
                  Deletar
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ getLabel(item.status) }}
        </v-chip>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.start_date="{ item }">
        {{ item.start_date | dateFormatBr }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.company_id="{ item }">
        {{ item.provider.code }} - {{ item.provider.name }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.type="{ item }">
        {{ getTextType(item.type) }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.payment="{ item }">
        {{ getLabelPromotion(item) }}
        <!-- {{ item.payment == null ? "TODAS AS CONDIÇÕES" : item.payment.name }} -->
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.discount="{ item }">
        {{ item.discount }}%
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.end_date="{ item }">
        {{ item.end_date | dateFormatBr }}
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="blue darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              color="blue darken-1"
              @click="editItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top color="red darken-1">
          <!-- eslint-disable-next-line -->
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="red darken-1"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Deletar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import * as CompanyPromotionAPI from "@/api/requests/CompanyPromotionRequest";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    dialogDelete: false,
    search: "",
    loading: false,
    headers: [
      {
        text: "ID",
        align: "right",
        value: "id",
        width: 55,
      },
      { text: "Fornecedor", value: "company_id", width: 180 },
      { text: "Descrição", value: "description", width: 200 },
      { text: "Tipo", value: "type", width: 180 },
      { text: "Detalhamento", value: "payment", width: 180 },
      // { text: "Desconto", value: "discount", width: 100 },
      { text: "Data Inicial", value: "start_date", width: 100 },
      { text: "Data Final", value: "end_date", width: 100 },
      { text: "Status", value: "status", width: 60 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 100,
        align: "right",
      },
    ],
    typePromotions: [
      { value: 1, text: "Desconto na condição de pagamento" },
      { value: 2, text: "Promoção de prazo especial" },
      { value: 3, text: "Promoção de produtos (preço)" },
    ],
    promotions: [],
    editedItem: {
      id: "",
      name: "",
      status: 1,
    },
    defaultItem: {
      id: "",
      name: "",
      status: 1,
    },
    past_promotions: false,
    alert_message: "",
    type_alert: "",
  }),

  computed: {},

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    past_promotions(newValue) {
      if (newValue === true) {
        this.getPromotions("past-promotions=true");
      } else {
        this.getPromotions("");
      }
    },
  },
  filters: {
    dateFormatBr: function (value) {
      return value.split("-").reverse().join("/");
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.getPromotions("");
    },
    getColor(status) {
      return status == 1 ? "green" : "red";
    },
    getLabel(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },

    async getPromotions(past_promotions) {
      this.loading = true;
      this.promotions = [];
      try {
        this.promotions = await CompanyPromotionAPI.getAll(
          `?${past_promotions}`
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    editItem(item) {
      this.$router.push({
        name: "ProviderPromotionsEdit",
        params: { id: item.id },
      });
    },
    deleteItem(item) {
      // alert("A Implementar");
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.loading = true;
      this.closeDelete();
      try {
        await CompanyPromotionAPI.destroy(this.editedItem.id);
        this.alert_message = "Promoção deletada com sucesso";
        this.type_alert = "success";
        this.initialize();
      } catch (error) {
        this.alert_message = `Ocorreu um problema ao deletar esta Promoção: ${error.message}`;
        this.type_alert = "error";
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    getTextType(type) {
      console.log(type);
      return this.typePromotions.find((item) => item.value === type).text;
    },
    getLabelPromotion(item) {
      if (item.type == 3) return "";
      if (item.payment === null) {
        return `Desconto: ${item.discount}% em todas as condições`;
      } else {
        if (item.type === 2) {
          return `Condição: ${item.payment.name}`;
        } else {
          return `${item.discount}% em ${item.payment.name}`;
        }
      }
    },
  },
};
</script>
